import { useEffect, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { AppMenuDrawer } from '../components/AppMenuDrawer';
import { DownloadQrBlock } from '../components/DownloadQrBlock';
import { IcpFooter } from '../components/IcpFooter';
import { appConfig } from '../config/appConfig';
import { ActiveSubjectProvider } from '../context/ActiveSubjectContext';
import { useAuth } from '../context/AuthContext';
import {
  detectClient,
  KELIRIJI_IOS_APPLE_ID,
  parseStoreKey,
  resolveJumpUrl,
} from '../data/kelirijiDownload';

export function DownloadPage() {
  const { status: authStatus, user } = useAuth();
  const [params] = useSearchParams();
  const forcedStore = parseStoreKey(params.get('store') || params.get('channel') || params.get('market'));
  const client = useMemo(() => {
    if (typeof navigator === 'undefined') return detectClient('');
    return detectClient(navigator.userAgent, {
      platform: navigator.platform,
      maxTouchPoints: navigator.maxTouchPoints,
    });
  }, []);
  const stayOnPage = params.get('view') === '1' || params.get('stay') === '1';
  const jumpUrl = resolveJumpUrl(client, forcedStore);
  const shouldJump = Boolean(jumpUrl) && client.os !== 'other' && !stayOnPage;

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'apple-itunes-app';
    meta.content = `app-id=${KELIRIJI_IOS_APPLE_ID}`;
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  useEffect(() => {
    if (!shouldJump || !jumpUrl) return;
    window.location.replace(jumpUrl);
  }, [jumpUrl, shouldJump]);

  const pageStatus = client.inAppBlocker
    ? '请长按二维码识别，或点右上角在浏览器中打开'
    : shouldJump
      ? '正在打开应用商店…'
      : '长按二维码可保存或发给别人扫。手机扫码会按品牌自动进商店。';
  const signedIn = authStatus === 'signed-in' && Boolean(user);

  return (
    <ActiveSubjectProvider>
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="border-b border-border bg-surface px-4 py-3">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 text-sm font-semibold text-ink hover:text-primary">
            <img src="/icon_main.png" alt="" className="h-8 w-8 rounded-lg" />
            {appConfig.appName}
          </Link>
          <div className="flex items-center gap-2">
            {signedIn ? (
              <AppMenuDrawer />
            ) : authStatus === 'signed-out' ? (
              <Link to="/login" className="text-sm font-medium text-primary hover:underline">
                登录
              </Link>
            ) : null}
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-8 sm:px-6 sm:py-10">
        <p className="text-sm font-medium text-primary">{pageStatus}</p>
        <h1 className="mt-3 text-3xl font-semibold text-ink">下载颗粒日记</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          统一链接是 www.keliriji.com/download。手机扫码会进对应商店；电脑或菜单进入则显示本页。
        </p>

        <div className="mt-8">
          <DownloadQrBlock />
        </div>
      </main>
      <IcpFooter />
    </div>
    </ActiveSubjectProvider>
  );
}
